import { useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import { MdKeyboardDoubleArrowLeft, MdNotifications } from "react-icons/md";
import { FaCalendarDays } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import ClickOutside from "../ClickOutside";
import DropdownUser from "./DropdownUser";
import Breadcrumb from "../Breadcrumbs/Breadcrumb";
import { FaBarsStaggered } from "react-icons/fa6";
import { RiArrowRightDoubleFill } from "react-icons/ri";

const Header = ({
  sidebarOpen,
  setSidebarOpen,
  sidebarCollapsed,
  setSidebarCollapsed,
}) => {
  const navigate = useNavigate();
  const trigger = useRef(null);
  const sidebar = useRef(null);

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });
  const [userName, setUserName] = useState("");
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const notificationBtnRef = useRef(null);

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axiosInstance.get(
        "/Followup/GetAllTodayNotification"
      );
      const todayNotifs = response.data || [];
      setNotifications(todayNotifs);
      setNotificationCount(todayNotifs.length);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    }
  };

  return (
    <>
      <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur-md border-b border-slate-200 shadow-sm transition-all duration-300">
        <div className="flex items-center justify-between px-6 py-3">
          <div className="flex items-center gap-4">
            <div className="lg:hidden">
              <button
                aria-controls="sidebar"
                onClick={(e) => {
                  e.stopPropagation();
                  setSidebarOpen(!sidebarOpen);
                }}
                className="w-10 h-10 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center text-slate-600 hover:text-primary transition-colors"
              >
                <FaBarsStaggered className="text-[18px]" />
              </button>
            </div>

            <div className="hidden lg:block">
              <button
                ref={sidebar}
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                className="w-10 h-10 bg-slate-50 border border-slate-200 rounded-xl flex items-center justify-center text-slate-500 hover:text-primary hover:border-primary/30 transition-all duration-300 shadow-sm"
              >
                {sidebarCollapsed ? (
                  <RiArrowRightDoubleFill className="w-5 h-5" />
                ) : (
                  <MdKeyboardDoubleArrowLeft className="w-5 h-5" />
                )}
              </button>
            </div>

            {/* <div className="hidden sm:block">
              <form>
                <div className="relative">
                  <button className="absolute left-2 top-1/2 -translate-y-1/2 p-1">
                    <IoIosSearch className="w-5 h-5 text-gray-500" />
                  </button>
                  <input
                    type="text"
                    placeholder="Search..."
                    className="pl-9 pr-4 py-1.5 w-72 bg-gray-100 text-sm rounded-md focus:outline-none"
                  />
                </div>
              </form>
            </div> */}
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/calendar")}
              className="w-10 h-10 flex items-center justify-center rounded-xl text-slate-500 hover:text-primary hover:bg-primary/5 transition-all duration-300"
              title="Calendar"
            >
              <FaCalendarDays className="w-5 h-5" />
            </button>

            <button
              ref={notificationBtnRef}
              onClick={() => setShowNotifications((prev) => !prev)}
              className="relative w-10 h-10 flex items-center justify-center rounded-xl text-slate-500 hover:text-primary hover:bg-primary/5 transition-all duration-300"
              title="Notifications"
            >
              <MdNotifications className="w-[22px] h-[22px]" />
              {notificationCount > 0 && (
                <span className="absolute top-2 right-2 h-4 w-4 flex items-center justify-center text-[10px] font-bold text-white bg-red-500 rounded-full border-2 border-white">
                  {notificationCount}
                </span>
              )}
            </button>

            <div className="w-px h-6 bg-slate-200 mx-2 hidden sm:block" />

            <DropdownUser userName={userName} />
          </div>
        </div>

        <div className="w-full px-6 py-2 bg-slate-50/50 border-t border-slate-100">
          <Breadcrumb />
        </div>
      </header>

      {showNotifications && (
        <ClickOutside
          exceptionRef={notificationBtnRef}
          onClick={() => setShowNotifications(false)}
          className="fixed right-6 top-20 z-99999 w-80 bg-white rounded-2xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] border border-slate-100 p-2 overflow-hidden animate-in fade-in slide-in-from-top-4 duration-300"
        >
          <div className="px-4 py-3 border-b border-slate-50 flex items-center justify-between">
            <h4 className="text-sm font-bold text-slate-900">Recent Notifications</h4>
            {notificationCount > 0 && (
              <span className="text-[10px] font-black bg-primary/10 text-primary px-2 py-0.5 rounded-full uppercase tracking-wider">
                {notificationCount} New
              </span>
            )}
          </div>

          <div className="max-h-[400px] overflow-y-auto no-scrollbar">
            {notifications.length === 0 ? (
              <div className="p-10 text-center">
                <div className="w-12 h-12 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-3">
                  <MdNotifications className="text-slate-300 text-xl" />
                </div>
                <p className="text-xs text-slate-400 font-medium tracking-wide">No notifications today</p>
              </div>
            ) : (
              <ul className="p-1 flex flex-col gap-1">
                {notifications.map((item, index) => (
                  <li key={index}>
                    <button className="w-full text-left p-3 rounded-xl hover:bg-slate-50 transition-colors group">
                      <div className="flex gap-3">
                        <div className="w-2 h-2 rounded-full bg-primary mt-1.5 shrink-0 shadow-lg shadow-primary/30" />
                        <div>
                          <p className="text-[13px] font-bold text-slate-700 leading-tight mb-1 group-hover:text-primary transition-colors">
                            {item.subject}
                          </p>
                          <p className="text-[11px] font-medium text-slate-400">Just now • Follow up</p>
                        </div>
                      </div>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="p-2 border-t border-slate-50">
            <button className="w-full py-2 text-[11px] font-black text-slate-500 uppercase tracking-widest hover:text-primary transition-colors">
              View All Notifications
            </button>
          </div>
        </ClickOutside>
      )}
    </>
  );
};

export default Header;
